var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Copy@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Copy",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6,6.00000118 L15.6,3.60000142 C15.6,2.93725978 15.0627417,2.40000154 14.4,2.40000154 L11.2,2.40000154",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4,2.40000154 L1.2,2.40000154 C0.5372583,2.40000154 0,2.93725978 0,3.60000142 L0,16.8000001 C0,17.4627418 0.5372583,18 1.2,18 L6,18",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9368,3.18960146 C10.8549236,3.43464248 10.625558,3.59990166 10.3672,3.60000142 L5.2328,3.60000142 C4.97444201,3.59990166 4.74507642,3.43464248 4.6632,3.18960146 L3.8632,0.789601696 C3.80186075,0.606570139 3.8324564,0.405197059 3.94539051,0.248643741 C4.05832463,0.0920904237 4.23976415,-0.000467229348 4.4328,0 L11.1672,0 C11.3602359,-0.000467229348 11.5416754,0.0920904237 11.6546095,0.248643741 C11.7675436,0.405197059 11.7981392,0.606570139 11.7368,0.789601696 L10.9368,3.18960146 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.4 8.40000095 18 8.40000095 18 18 8.4 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8,
    y1: 10.8000007,
    x2: 15.6,
    y2: 10.8000007,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8,
    y1: 13.2000005,
    x2: 15.6,
    y2: 13.2000005,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8,
    y1: 15.6000002,
    x2: 12.6,
    y2: 15.6000002,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.7221acd7fe103ab151ccad8772d8c3f0.svg";
export { ForwardRef as ReactComponent };